import React, { useCallback, useContext, useEffect } from 'react';
import classNames from 'classnames';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { Button } from 'ncoded-component-library';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import DataRoomNodeTagAndVersion from 'components/DataRoomNodeTagAndVersion';
import DocumentViewContext from 'providers/DocumentView/DocumentView.context';
import { getNodeMimeType } from 'utils';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';
import { isMaximumSelected } from 'router/subrouters/DataRoom/utils';

import './DataRoomNodePreview.styles.scss';

type DataRoomNodePreviewProps = {
  className?: string;
  node: DataRoomNode;
  siblings?: DataRoomNode[];
  dataRoomName: string;
  ownerId: string;
  userSide: QAndASides;
  dealRoomId: string;
  hasMoreSiblings?: boolean;
  onLoadMoreSiblings?: () => void;
};

const DataRoomNodePreview: React.FC<DataRoomNodePreviewProps> = (props) => {
  const {
    className,
    node,
    siblings,
    dataRoomName,
    userSide,
    ownerId,
    dealRoomId,
    hasMoreSiblings,
    onLoadMoreSiblings,
  } = props;

  const { _id, name, tag, version, fileSecurity } = node || {};

  const disabled = !_id;

  const classes = classNames('data-room-node-preview', className);

  const { openNode, updateSiblings } = useContext(DocumentViewContext);

  const handleOpen = useCallback(() => {
    if (disabled) return;

    openNode(node, { dataRoomName, userSide, ownerId, dealRoomId }, siblings);
  }, [
    disabled,
    node,
    siblings,
    dataRoomName,
    userSide,
    ownerId,
    dealRoomId,
    openNode,
  ]);

  useEffect(() => {
    if (disabled) return;

    if (siblings) {
      updateSiblings(siblings, hasMoreSiblings, onLoadMoreSiblings);
    }
  }, [siblings, disabled, hasMoreSiblings, onLoadMoreSiblings, updateSiblings]);

  return (
    <Button className={classes} disabled={disabled} onClick={handleOpen}>
      <MymeTypeIcon
        mimeType={getNodeMimeType(node)}
        isLocked={isMaximumSelected(fileSecurity)}
      />
      <span>
        <span>{name}</span>
        <DataRoomNodeTagAndVersion tag={tag} version={version} />
      </span>
    </Button>
  );
};

export default DataRoomNodePreview;
